// 获取浏览设备类型
export function getEquipmentType() {
  var browser = {
    versions: (function() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        trident: u.indexOf("Trident") > -1, //IE内核
        presto: u.indexOf("Presto") > -1, //opera内核
        webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
        iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, //是否iPad
        webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
  };

  if (
    browser.versions.ios ||
    browser.versions.iPhone ||
    browser.versions.iPad
  ) {
    //如果是ios系统
    return "ios";
  } else if (browser.versions.android) {
    //如果是Android系统 就
    return "android";
  } else {
    return "wx";
    // var ua = navigator.userAgent.toLowerCase();
    // // 如果是微信
    // if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //     return ('wx')
    // } else {}
  }
}
// 获取query后面的json字符串参数,格式为（?"params"={"a":"1","b":"2"})
export function getUrlQueryParams(url) {
  if (url.indexOf("=") < 0) {
    return null;
  }
  return JSON.parse(decodeURIComponent(url.slice(url.indexOf("=") + 1)));
}
//过滤时间，如过滤 22:01：15
export function regExpTime1(time, boolean) {
  var reg = /(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d/;
  if (boolean) {
    return time.replace(reg, "");
  } else {
    return time.match(reg);
  }
}
// 时间戳转日期格式（YYYY-MM-dd HH:mm:ss）
export function formatUnixtimestamp(unixtimestamp) {
  var unixtimestamp = new Date(unixtimestamp);
  var year = 1900 + unixtimestamp.getYear();
  var month = "0" + (unixtimestamp.getMonth() + 1);
  var date = "0" + unixtimestamp.getDate();
  var hour = "0" + unixtimestamp.getHours();
  var minute = "0" + unixtimestamp.getMinutes();
  var second = "0" + unixtimestamp.getSeconds();
  return (
    year +
    "-" +
    month.substring(month.length - 2, month.length) +
    "-" +
    date.substring(date.length - 2, date.length) +
    " " +
    hour.substring(hour.length - 2, hour.length) +
    ":" +
    minute.substring(minute.length - 2, minute.length) +
    ":" +
    second.substring(second.length - 2, second.length)
  );
}
// 获取hash后面的参数
export function getHashParams(key) {
  let res = null;
  location.hash
    .slice(location.hash.indexOf("?") + 1)
    .split("&")
    .forEach((item, index) => {
      if (item.indexOf(key) > -1) {
        console.log(item);
        res = item.slice(key.length + 1);
      }
    });

  return res;
}
/**
 * 将秒转换为 分:秒
 * s int 秒数
 */
export function s_to_hs(s) {
  //计算分钟
  //算法：将秒数除以60，然后下舍入，既得到分钟数
  var h;
  h = Math.floor(s / 60);
  //计算秒
  //算法：取得秒%60的余数，既得到秒数
  s = s % 60;
  //将变量转换为字符串
  h += "";
  s += "";
  //如果只有一位数，前面增加一个0
  h = h.length == 1 ? "0" + h : h;
  s = s.length == 1 ? "0" + s : s;
  return h + ":" + s;
}

// 匹配日期格式（mm-dd)
export function mmddRegExp(time) {
  var reg = /((0[1-9])|(1[0-2]))-((0[1-9])|((1|2)[0-9])|(3[0-1]))/g;

  return time.match(reg).join("");
}
// REM是根据根结点来计算各个子节点的值，所以根结点也要做响应式变化。utils/setRem.js
export function setRem(baseWidth) {
  const dpr = window.devicePixelRatio;
  const currentWidth = document.documentElement.clientWidth;
  let remSize = 0;
  let scale = 0;
  scale = currentWidth / baseWidth;
  remSize = baseWidth / 10;
  remSize = remSize * scale;
  document.documentElement.style.fontSize = remSize + "px";
  document.documentElement.setAttribute("data-dpr", `${dpr}`);
}
export function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  ); // localStorage.setItem('isiphone',flag)

  localStorage.setItem("ismobile", flag ? 1 : 0);

  return flag;
}
// 函数节流
export function throttle(method,delay,duration){
   
    var timer=null;
    var begin=new Date();    
    return function(){                
        console.log(timer);
       
        var current=new Date();        
        clearTimeout(timer);
        console.log(current,begin);
        if(current-begin>=duration){
            console.log(1);
            method()
            begin=current;
        }else{
            timer=setTimeout(function(){
                console.log(2);
                method()
            },delay);
        }
    }
}
// 函数防抖
export function debounce(fn,delay){
    let timer = null //借助闭包
    return function() {
        if(timer){
            clearTimeout(timer) 
        }
        timer = setTimeout(fn,delay) // 简化写法
    }
}
